import { InjectionKey } from 'vue'
// The one place vuex's useStore belongs: `useStore` below binds it to `key`.
// eslint-disable-next-line no-restricted-imports
import { createStore, Store, useStore as baseUseStore } from 'vuex'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import state, { HexaplaState } from './state'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence<HexaplaState>({
  storage: window.localStorage,
  reducer: (state) => ({
    user: state.user,
    viewMessages: state.viewMessages,
    newLemma: state.newLemma,
    draftOwnerId: state.draftOwnerId,
    editingLemmaId: state.editingLemmaId,
  }),
})

export const key: InjectionKey<Store<HexaplaState>> = Symbol()

export function useStore(): Store<HexaplaState> {
  return baseUseStore(key)
}

export default createStore<HexaplaState>({
  state,
  mutations,
  getters,
  actions,
  plugins: [vuexLocal.plugin],
})
